import React from 'react';
import '../logbook/MobileWidePages.css';

export default function MobileAircraftTechLog({
  aircraft,
  bookings,
  userMap,
  techLogMap,
  expandedBookingId,
  toggleBooking,
  renderEditor,
  paperDraft,
  setPaperDraft,
  savePaperDraft,
  paperNotice,
}) {
  return (
    <div className="mobile-wide-page mobile-tech-log">
      <div className="mobile-wide-list">
        <article className="mobile-wide-card mobile-tech-log__opening-entry">
          <header>
            <div><strong>{aircraft?.registration || 'Aircraft'}</strong><span>Opening technical-log entry</span></div>
            <span>{paperNotice || 'Pending'}</span>
          </header>
          <details>
            <summary>View and edit opening entry</summary>
            <div className="mobile-wide-fields">
              {paperFields.map(([field, label]) => (
                <label key={field}>
                  <span>{label}</span>
                  <input value={paperDraft[field] ?? ''} onChange={(event) => setPaperDraft((previous) => ({ ...previous, [field]: event.target.value }))} />
                </label>
              ))}
            </div>
          </details>
          <button type="button" className="mobile-wide-card__action" onClick={savePaperDraft}>Save opening entry</button>
        </article>

        {bookings.map((booking) => {
          const entry = techLogMap[String(booking.id)] || {};
          const pilot = userMap[String(booking.user_id)];
          const expanded = expandedBookingId === booking.id;
          return (
            <article className="mobile-wide-card" key={booking.id}>
              <header>
                <div><strong>{aircraft?.registration || `Aircraft ${booking.aircraft_id}`}</strong><span>{aircraft?.icao_type || 'Aircraft'}</span></div>
                <time>{booking.date || 'Date not set'}</time>
              </header>
              <div className="mobile-wide-card__route">
                {entry.departureAirfield || '—'} → {entry.arrivalAirfield || '—'}
              </div>
              <div className="mobile-wide-card__facts">
                <div><span>Flight</span><b>{entry.departureTime || booking.time || '—'}–{entry.arrivalTime || booking.end_time || '—'}</b></div>
                <div><span>Pilot</span><b>{pilot?.full_name || pilot?.email || booking.user_id}</b></div>
                <div><span>Status</span><b>{Object.keys(entry).length ? 'Log updated' : 'Log pending'}</b></div>
              </div>
              <details>
                <summary>Technical details</summary>
                <dl className="mobile-wide-details">
                  <div><dt>Flight hours</dt><dd>{entry.flightTime || '—'}</dd></div>
                  <div><dt>Fuel / oil</dt><dd>{entry.fuelUpliftLitres || '0'} L / {entry.oilUpliftLitres || '0'} L</dd></div>
                  <div><dt>Next check</dt><dd>{entry.nextCheck || entry.checkCountdownHours || '—'}</dd></div>
                  <div><dt>Defects</dt><dd>{entry.defect || entry.snag || 'None recorded'}</dd></div>
                  <div><dt>Rectification</dt><dd>{entry.rectification || '—'}</dd></div>
                  <div><dt>Remarks</dt><dd>{entry.remarks || entry.notes || '—'}</dd></div>
                </dl>
              </details>
              <button type="button" className="mobile-wide-card__action" onClick={() => toggleBooking(booking.id)}>
                {expanded ? 'Hide Entry' : 'View / Edit Entry'}
              </button>
              {expanded ? <div className="mobile-wide-card__editor">{renderEditor(booking)}</div> : null}
            </article>
          );
        })}
        {bookings.length === 0 ? <div className="mobile-wide-empty">No completed flight entries yet.</div> : null}
      </div>
    </div>
  );
}

const paperFields = [
  ['flightNumber', 'Flight number'],
  ['flightDate', 'Date'],
  ['departureAirfield', 'Departure airfield'],
  ['arrivalAirfield', 'Arrival airfield'],
  ['departureTime', 'Departure time'],
  ['arrivalTime', 'Arrival time'],
  ['flightTime', 'Flight hours'],
  ['fuelUpliftLitres', 'Fuel uplift'],
  ['oilUpliftLitres', 'Oil uplift'],
  ['signature', 'Signature'],
  ['nextCheck', 'Next check'],
  ['defect', 'Defects'],
  ['rectification', 'Rectification'],
  ['engineerSignature', 'Engineer signature'],
  ['remarks', 'Remarks'],
];